export const OPT_TIPOS = [
  { v: 'subir_presupuesto', label: 'Subir presupuesto' },
  { v: 'bajar_presupuesto', label: 'Bajar presupuesto' },
  { v: 'cambiar_creatividad', label: 'Cambiar creatividad' },
  { v: 'pausar_anuncio', label: 'Pausar anuncio' },
  { v: 'cambiar_publico', label: 'Cambiar público' },
  { v: 'nuevo_angulo', label: 'Nuevo ángulo / copy' },
  { v: 'cambiar_puja', label: 'Cambiar puja' },
  { v: 'otro', label: 'Otro' },
];

export const OPT_CONCLUSIONES = [
  { v: 'funciono', label: 'Funcionó', cls: 'bg-emerald-100 text-emerald-700 border-emerald-300' },
  { v: 'no_funciono', label: 'No funcionó', cls: 'bg-red-100 text-red-700 border-red-300' },
  { v: 'neutro', label: 'Neutro', cls: 'bg-gray-100 text-gray-600 border-gray-300' },
];
